// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".online-chat-root .overlay[data-v-3cc5ea66]{padding:1.5em!important;z-index:2147483647!important}.online-chat-root .append-to-body[data-v-3cc5ea66]{position:fixed!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/ChatModal.vue"],"names":[],"mappings":"AAII,4CAEI,uBAAA,CADA,4BACA,CAGJ,mDACI,wBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
